import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import './style.scss';

PageSpinner.propTypes = {
  className: PropTypes.string,
};

export function PageSpinner(props) {
  const { className = '' } = props;

  return (
    <div className={`pd-section ${className}`}>
      <Spin size="large" indicator={<LoadingOutlined />} />
    </div>
  );
}

export default { PageSpinner };
